import React from 'react';

const deliveryPoints = [
  'India-based engineering and delivery capability',
  'Support for UK and international consulting projects',
  'Flexible engagement for MVPs, enhancements and support',
  'Clear communication, documentation and delivery tracking',
];

export default function DeliveryModel() {
  return (
    <section id="delivery" className="section light">
      <div className="split">
        <div>
          <p className="eyebrow">Delivery Model</p>
          <h2>Built to support global consulting and product teams</h2>
          <p>
            Arthanova Global provides scalable engineering and delivery support for 
            software projects, product builds and long-term technology operations across global markets.
          </p>
        </div>

        <ul className="check-list">
          {deliveryPoints.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}